import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { PageDTO } from '../../../api/page-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';
import { PagesContent } from '../pages-content-page/pages-content-app';
interface SavePageModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedPage?: PageDTO;
    onHide: () => void;
    onSave: (values: PageDTO) => void;
    onDelete?: (page: PageDTO) => void;
}

export function SavePageModal({
    show,
    allowEdit,
    selectedPage,
    onHide,
    onSave,
    onDelete,
}: SavePageModalProps) {
    const PageSchema = yup.object().shape({
        id: yup.string().required(' '),
        title: yup.string().required(' '),
    });

    const defaultValues: PageDTO = {
        id: selectedPage?.id,
        title: selectedPage ? selectedPage.title : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={PageSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    size="lg"
                    show={show}
                    onHide={onHide}
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedPage ? 'edit-page' : 'new-page'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedPage && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedPage)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="id"
                                name="id"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                            <FormikTextField
                                label="title"
                                name="title"
                                readOnly={!allowEdit}
                                className="flex-grow-1"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                    {selectedPage && selectedPage.id && <PagesContent pageId={selectedPage.id} />}
                </BasicModal>
            )}
        </Formik>
    );
}
